import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import GetSettings from "../IsraelSettings";
import AzyUpdateProducts from './AzyUpdateProducts';
import AzyAccounts from 'components/adminPanel/Settings/AzyAccounts';
import AzyProductsTable from 'components/adminPanel/Settings/AzyProductsTable';
import translate from '../../../../../i18n/translate';
import { connect } from 'react-redux';

const AzySettings = ({ isDarktheme }) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function a11yProps(index) {
        return {
            id: `azy-tab-${index}`,
            'aria-controls': `azy-tabpanel-${index}`,
        };
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="azy tabs">
                    <Tab sx={!isDarktheme ? '' : { color: 'white' }} label={translate("Accounts")} {...a11yProps(0)} />
                    <Tab sx={!isDarktheme ? '' : { color: 'white' }} label="Azy Settings" {...a11yProps(1)} />
                    <Tab sx={!isDarktheme ? '' : { color: 'white' }} label="Azy Products" {...a11yProps(2)} />
                    <Tab sx={!isDarktheme ? '' : { color: 'white' }} label="Update Azy Products" {...a11yProps(3)} />
                </Tabs>
            </Box>

            {value === 0 && <AzyAccounts />}
            {value === 1 && <GetSettings carrier="azy" />}
            {value === 2 && <AzyProductsTable />}
            {value === 3 && <AzyUpdateProducts />}
        </Box>
    );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => ({
    isDarktheme
});

export default connect(mapStateToProps, null)(AzySettings);
